import monsters from '../../mock/monsters.json'

const reducer = (state = monsters, action) => {
    return state
}

export default reducer